export default __webpack_public_path__ + "static/media/1.d40ae200.jpg";